export default "__VITE_ASSET__666f8793__"